import { render, staticRenderFns } from "./EditRoomModal.vue?vue&type=template&id=2f1a6643&"
import script from "./EditRoomModal.vue?vue&type=script&lang=js&"
export * from "./EditRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports